<template>
  <div class="my-2" :class="{ 'my-1': compact }">
    <p v-if="loading" class="text-sm text-gray-600" :class="{ 'text-xs': compact }">
      {{ compact ? '…' : 'Checking where to watch…' }}
    </p>
    <p v-else-if="error" class="text-sm text-red-700" :class="{ 'text-xs': compact }">
      {{ compact ? '⚠︎' : error }}
    </p>

    <div v-else-if="hasProviders" class="flex flex-wrap items-center gap-3" :class="{ 'gap-1': compact }">
      <div v-if="providers.flatrate.length" class="flex items-center gap-1.5" :class="{ 'gap-1': compact }">
        <span v-if="!compact" class="mr-0.5 text-xs uppercase text-gray-400">Stream</span>
        <a
          v-for="provider in providers.flatrate"
          :key="`flatrate-${provider.id}`"
          :href="providers.link ?? undefined"
          target="_blank"
          rel="noopener noreferrer"
          :title="provider.name"
          class="inline-flex"
          @click.stop
        >
          <img
            v-if="provider.logoUrl"
            :src="provider.logoUrl"
            :alt="provider.name"
            :width="compact ? 20 : 32"
            :height="compact ? 20 : 32"
            class="block rounded-md"
          />
          <span v-else>{{ provider.name }}</span>
        </a>
      </div>

      <!-- <div v-if="providers.rent.length" class="jw-group">
        <span class="jw-group-label">Rent</span>
        <a
          v-for="provider in providers.rent"
          :key="`rent-${provider.id}`"
          :href="providers.link ?? undefined"
          target="_blank"
          rel="noopener noreferrer"
          :title="provider.name"
        >
          <img v-if="provider.logoUrl" :src="provider.logoUrl" :alt="provider.name" width="32" height="32" />
          <span v-else>{{ provider.name }}</span>
        </a>
      </div>

      <div v-if="providers.buy.length" class="jw-group">
        <span class="jw-group-label">Buy</span>
        <a
          v-for="provider in providers.buy"
          :key="`buy-${provider.id}`"
          :href="providers.link ?? undefined"
          target="_blank"
          rel="noopener noreferrer"
          :title="provider.name"
        >
          <img v-if="provider.logoUrl" :src="provider.logoUrl" :alt="provider.name" width="32" height="32" />
          <span v-else>{{ provider.name }}</span>
        </a>
      </div> -->

      <a
        v-if="!compact"
        class="ml-auto text-xs text-gray-400"
        :href="providers.link ?? undefined"
        target="_blank"
        rel="noopener noreferrer"
      >
        Data by JustWatch
      </a>
    </div>

    <p v-else class="text-sm text-gray-600" :class="{ 'text-xs': compact }">
      {{ compact ? 'Not available' : `Not currently available to watch in ${region}.` }}
    </p>
  </div>
</template>

<script setup>
const props = defineProps({
  tmdbId: {
    type: [String, Number],
    required: true
  },
  region: {
    type: String,
    default: 'GB'
  },
  compact: {
    type: Boolean,
    default: false
  }
})

const providers = ref(null)
const loading = ref(true)
const error = ref('')

const hasProviders = computed(() => {
  const p = providers.value
  return !!p && (p.flatrate.length || p.rent.length || p.buy.length)
})

async function load() {
  if (!props.tmdbId) return

  loading.value = true
  error.value = ''

  try {
    providers.value = await $fetch('/api/watch-providers', {
      query: { tmdbId: props.tmdbId, region: props.region }
    })
  } catch (err) {
    error.value = err?.data?.statusMessage || 'Failed to load watch providers.'
  } finally {
    loading.value = false
  }
}

watch(() => [props.tmdbId, props.region], load, { immediate: true })
</script>
